import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DealerDetailsComponent = _resolveComponent("DealerDetailsComponent");
    const _component_FiltersComponent = _resolveComponent("FiltersComponent");
    const _component_CommentsComponent = _resolveComponent("CommentsComponent");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_DealerDetailsComponent),
        _createVNode(_component_FiltersComponent),
        (_ctx.hasReviews)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_CommentsComponent)
            ]))
            : _createCommentVNode("v-if", true)
    ]));
}
